import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { TextField } from '@hub-la/design-system';
import { forwardRef } from 'react';

const PhoneField = /*#__PURE__*/forwardRef((props, ref) => {
  const disabled = props['disabled'] === true;
  return jsx(TextField, Object.assign({}, props, {
    inputRef: ref,
    fullWidth: true,
    size: "normal",
    variant: "outlined",
    name: "phoneNumber",
    disabled: disabled,
    "data-testid": "phoneNumber"
  }));
});

export { PhoneField };
